<template>
<v-dialog :fullscreen="$vuetify.breakpoint.mobile"
          :value="value" :style="{ borderRadius: '50px' }"
          scrollable max-width="80%"
          persistent>
  <v-card class="d-flex flex-column">
    <v-card-title class="primary white--text">
      {{getTitle}}
      <v-spacer/>
      <v-btn text elevation="0" color="white" small @click="$emit('input', false)">
        Fechar <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>
    <v-card-text class="py-4 flex-grow-1" 
      style="height: 80%;"
      v-if="value">

      <v-form ref="form" @submit.prevent="save" v-model="formValid" lazy-validation>
        <GestaoAcessoForm v-model="item"/>
      </v-form>

    </v-card-text>
    <v-divider/>
    <v-card-actions>
      <v-spacer/>
      <v-btn color="success" @click="$emit('input', false)" :disabled="loading">Cancelar</v-btn>
      <v-btn color="primary" @click="save" :disabled="!formValid || loading">Salvar</v-btn>
    </v-card-actions>
  </v-card>
  <v-overlay :value="loading" absolute>
    <v-progress-circular
      indeterminate
      color="primary"
      class="ma-4"
    ></v-progress-circular>
  </v-overlay>    
</v-dialog>
</template>

<script>
import GestaoAcessoForm from "../forms/GestaoAcessoForm";
import {create, update} from "../../../api/gestaoAcesso";
import {ApiError} from "../../../api/core";
export default {
  name: "CreateEditGestaoAcessoDialog",
  components: {GestaoAcessoForm},
  props: ['value','item'],
  data () {
    return {
      formValid: false,
      loading: false,
    }
  },
  computed: {
    getTitle() {
      return this.item?.id ? 'Editar Acesso' : 'Adicionar Acesso'
    }
  },
  methods: {
    async save() {
      try {
        this.loading = true;
        if(this.$refs.form.validate()) {
          if(this.item.id) {
            await update(this.item.id, {
              link: encodeURIComponent(this.item.link),
              titulo: this.item.titulo,
              nivelAcesso: this.item.niveisAcesso.map(d => d.key).join(','),
              idPai: this.item.idPai,
              ordem: this.item.ordem,
              url: encodeURIComponent(this.item.url),
              icon: this.item.icon,
              flgVisivel: this.item.flgVisivel,
            });
          } else {
            await create({
              link: this.item.link,
              titulo: this.item.titulo,
              nivelAcesso: this.item.niveisAcesso.map(d => d.key).join(','),
              idPai: this.item.idPai,
              ordem: this.item.ordem,
              url: this.item.url,
              icon: this.item.icon,
              flgVisivel: this.item.flgVisivel,
            })
          }
          this.$emit('input', false);
          this.$emit('onSave');
          this.$toast.success(`Acesso ${this.item.id ? 'atualizado' : 'criado'} com sucesso.`, {
            timeout: 3000
          })

        }
      } catch (err) {
        if(err instanceof ApiError) {
          this.$toast.error(err.message, {
           timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível ${this.item.id ? 'atualizar' : 'adicionar'} o Acesso.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    }
  },
}
</script>

<style scoped>

</style>